<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">Midnight in Westminster Abbey</h1>
<ol class="toc"><li id="toc-li-1"><a href="#/Text/ch001#about-the-author">About The Author</a></li>
<li id="toc-li-2"><a href="#/Text/ch002#dedication">Dedication</a></li>
<li id="toc-li-3"><a href="#/Text/ch003#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-4"><a href="#/Text/ch004#foreword">FOREWORD</a></li>
<li id="toc-li-5"><a href="#/Text/ch005#americans-expect">1 AMERICANS EXPECT</a><ol class="toc"><li id="toc-li-6"><a href="#/Text/ch005#the-kindness-of-strangers">THE KINDNESS OF STRANGERS</a><ol class="toc"><li id="toc-li-7"><a href="#/Text/ch005#cockaignein-london-town">COCKAIGNE—IN LONDON TOWN</a></li>
</ol></li>
</ol></li>
<li id="toc-li-8"><a href="#/Text/ch006#the-kings-ride">2 THE KINGS’ RIDE</a><ol class="toc"><li id="toc-li-9"><a href="#/Text/ch006#curtain-up">CURTAIN UP</a><ol class="toc"><li id="toc-li-10"><a href="#/Text/ch006#the-hundred-years-war">THE HUNDRED YEARS WAR</a></li>
<li id="toc-li-11"><a href="#/Text/ch006#spitting-feathers">SPITTING FEATHERS</a></li>
<li id="toc-li-12"><a href="#/Text/ch006#by-our-lady">BY OUR LADY</a></li>
<li id="toc-li-13"><a href="#/Text/ch006#earl-king">EARL KING</a></li>
<li id="toc-li-14"><a href="#/Text/ch006#turns-of-the-screw">TURNS OF THE SCREW</a></li>
<li id="toc-li-15"><a href="#/Text/ch006#charlie">CHARLIE</a></li>
<li id="toc-li-16"><a href="#/Text/ch006#the-two-faces-of-richard-ii">THE TWO FACES OF RICHARD II</a></li>
<li id="toc-li-17"><a href="#/Text/ch006#knight-soil">KNIGHT SOIL</a></li>
</ol></li>
</ol></li>
<li id="toc-li-18"><span href="#/Text/ch007#the-queens-party" title="Link target outside of Sample">3 THE QUEENS’ PARTY</span><ol class="toc"><li id="toc-li-19"><span href="#/Text/ch007#georgie-and-the-dragons" title="Link target outside of Sample">GEORGIE AND THE DRAGONS</span><ol class="toc"><li id="toc-li-20"><span href="#/Text/ch007#elizabeth-i-and-the-new-world" title="Link target outside of Sample">ELIZABETH I AND THE NEW WORLD</span></li>
<li id="toc-li-21"><span href="#/Text/ch007#reeling" title="Link target outside of Sample">REELING</span></li>
<li id="toc-li-22"><span href="#/Text/ch007#circles-of-deceit" title="Link target outside of Sample">CIRCLES OF DECEIT</span></li>
<li id="toc-li-23"><span href="#/Text/ch007#two-for-one-james-vi-and-i" title="Link target outside of Sample">TWO-FOR-ONE: JAMES VI AND I</span></li>
</ol></li>
</ol></li>
<li id="toc-li-24"><span href="#/Text/ch008#kings-revenge" title="Link target outside of Sample">4 KINGS’ REVENGE</span><ol class="toc"><li id="toc-li-25"><span href="#/Text/ch008#coronation-exercises" title="Link target outside of Sample">CORONATION EXERCISES</span><ol class="toc"><li id="toc-li-26"><span href="#/Text/ch008#showstopper" title="Link target outside of Sample">SHOWSTOPPER</span></li>
<li id="toc-li-27"><span href="#/Text/ch008#charlie-captured" title="Link target outside of Sample">CHARLIE CAPTURED</span></li>
<li id="toc-li-28"><span href="#/Text/ch008#a-cat-can-look-at-a-queen" title="Link target outside of Sample">A CAT CAN LOOK AT A QUEEN</span></li>
<li id="toc-li-29"><span href="#/Text/ch008#truth-or-consequences" title="Link target outside of Sample">TRUTH OR CONSEQUENCES</span></li>
<li id="toc-li-30"><span href="#/Text/ch008#high-stakes-in-the-l-shaped-room" title="Link target outside of Sample">HIGH STAKES IN THE L-SHAPED ROOM</span></li>
<li id="toc-li-31"><span href="#/Text/ch008#queen-for-a-day" title="Link target outside of Sample">QUEEN FOR A DAY</span></li>
<li id="toc-li-32"><span href="#/Text/ch008#heaven-sent" title="Link target outside of Sample">HEAVEN SENT</span></li>
<li id="toc-li-33"><span href="#/Text/ch008#five-a-side-football" title="Link target outside of Sample">FIVE-A-SIDE FOOTBALL</span></li>
<li id="toc-li-34"><span href="#/Text/ch008#signing-off" title="Link target outside of Sample">SIGNING OFF</span></li>
<li id="toc-li-35"><span href="#/Text/ch008#game-on" title="Link target outside of Sample">GAME ON</span></li>
</ol></li>
</ol></li>
<li id="toc-li-36"><span href="#/Text/ch009#hidden-figures" title="Link target outside of Sample">5 HIDDEN FIGURES</span><ol class="toc"><li id="toc-li-37"><span href="#/Text/ch009#when-thieves-fall-out" title="Link target outside of Sample">WHEN THIEVES FALL OUT</span></li>
<li id="toc-li-38"><span href="#/Text/ch009#escape-artists" title="Link target outside of Sample">ESCAPE ARTISTS</span></li>
</ol></li>
<li id="toc-li-39"><span href="#/Text/ch010#kings-and-queens-in-westminster" title="Link target outside of Sample">KINGS AND QUEENS IN WESTMINSTER</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?3ad487ce